//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import PreviewEditing from "./previewEditing";
import PreviewUi from "./previewUi";

export default class Preview extends Plugin {
  public static get pluginName() {
    return "Preview";
  }

  public static get requires() {
    return [PreviewEditing, PreviewUi];
  }
}
